export const selectAppointmentRequestsCount = (state) =>
	state.appointmentRequests.requestedAppointmentsCount
